import { Box, Flex } from '@televet/kibble-ui/build/chakra';
import { Text } from '@televet/kibble-ui/build/components/Text';
import DevModeDisplayJSON from 'pages/Settings/components/DevModeDisplayJSON';
import React from 'react';
import { CareBenefitType, CareBenefitUnitOfMeasure } from 'shared/types/graphql';
import { UsePetBenefitCareBenefit } from '../hooks/usePetBenefits';
import { centsToDollars, formatCurrency } from '../utils/currency';
import formatDate from 'date-fns/format';
import { Icon } from '@televet/kibble-ui/build/components/Icon';

interface RemainingBenefitRowProps {
  benefit: UsePetBenefitCareBenefit;
  enrollmentExpirationDate: string;
}
export const RemainingBenefitRow = ({ benefit, enrollmentExpirationDate }: RemainingBenefitRowProps): JSX.Element => {
  return (
    <Box key={benefit.id} mb={1}>
      <DevModeDisplayJSON key={benefit.id + 'dev'} src={{ __typename: 'BenefitStub', ...benefit }} />
      <Flex w="100%" alignItems="center" justifyContent="space-between">
        <Text size="sm">{benefit.title}</Text>
        {benefit.tangible ? (
          benefit.usageUnitOfMeasure === CareBenefitUnitOfMeasure.Cents ? (
            <Text size="sm" fontWeight="semibold">
              {formatCurrency(centsToDollars(benefit.quantity), true)}
              <Text variant="subtle" size="sm" fontWeight="normal">
                /{formatCurrency(centsToDollars(benefit.provided))}
              </Text>
            </Text>
          ) : (
            <Text size="sm" fontWeight="semibold">
              {benefit.quantity}
              <Text variant="subtle" size="sm" fontWeight="normal">
                /{benefit.provided}
              </Text>
            </Text>
          )
        ) : benefit.discountPercentage ? (
          <Text size="sm" fontWeight="semibold">
            {benefit.discountPercentage}%
          </Text>
        ) : (
          <Flex>
            <Icon name="checkmark" size="md" />
          </Flex>
        )}
      </Flex>
      {benefit.type === CareBenefitType.AccountCredit && benefit.carryoverQuantity > 0 && (
        <Flex justifyContent="space-between" mt={1}>
          <Box>
            <Text as="p" size="sm">
              Rollover IAC
            </Text>
            <Text as="p" variant="subtle" size="xs">
              Expires {formatDate(new Date(enrollmentExpirationDate), 'MM/dd/yy')}
            </Text>
          </Box>
          <Text size="sm" fontWeight="semibold">
            {formatCurrency(centsToDollars(benefit.carryoverQuantity), true)}
            <Text variant="subtle" size="sm" fontWeight="normal">
              /{formatCurrency(centsToDollars(benefit.carryoverProvided))}
            </Text>
          </Text>
        </Flex>
      )}
    </Box>
  );
};
